import gql from 'graphql-tag';

const mutationName = 'resetPasswordSendEmail';
const resetPasswordMutationName = 'resetPassword';

export const RESET_PASSWORD_SEND_EMAIL = {
  mutationName,
  mutationBody: gql`
    mutation ${mutationName}(
      $email: String!
    ) {
      ${mutationName}(
        email: $email
      ) {
        status
      }
    }
  `,
};

export const RESET_PASSWORD = {
  mutationName: resetPasswordMutationName,
  mutationBody: gql`
    mutation ${resetPasswordMutationName} (
      $input: ResetPasswordMutationInput!
    ) {
      ${resetPasswordMutationName} (
        input: $input
      ) {
        status
      }
    }
  `,
};
